var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowIosRight = function ArrowIosRight(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.36 18.768a1 1 0 0 1-.128-1.408L13.698 12 9.232 6.64a1 1 0 0 1 1.536-1.28l5 6a1 1 0 0 1 0 1.28l-5 6a1 1 0 0 1-1.408.128Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ArrowIosRight;